export const GET_DATA_CEPS = 'GET_DATA_CEPS'